module.exports = __webpack_public_path__ + "static/media/catalyst-monitor-heated-catalyst-monitor.62096088.svg";